import { formatDocument, formatToReal } from "../../../utils/utils";

const Administrador = ({ administradores }) => {
  const renderValor = (valor) =>
    valor != null && valor !== "0" ? (
      <span className="text-rose-600 font-semibold">{formatToReal(valor)}</span>
    ) : null;

  return (
    <>
      <div className="mt-3 overflow-hidden rounded-2xl border border-slate-200 bg-white">
        <div className="border-b border-slate-200 bg-slate-50 px-4 py-3">
          <div className="grid grid-cols-5 gap-3 text-[10px] font-semibold uppercase tracking-[0.28em] text-slate-500">
            <div className="col-span-2">Nome</div>
            <div className="text-center">Entrada</div>
            <div className="text-center">Débitos</div>
            <div>Pendências</div>
          </div>
        </div>

        {administradores?.length > 0 && (
          <div className="divide-y divide-slate-100">
            {administradores?.map((socio, index) => (
              <div
                key={index}
                className={`grid grid-cols-5 gap-3 px-4 py-3 text-sm items-center ${
                  index % 2 === 0 ? "bg-white" : "bg-slate-50/40"
                } hover:bg-slate-50`}
              >
                <div className="col-span-2">
                  <div className="font-medium text-slate-900">
                    {socio?.nome || "-"}
                  </div>
                  <div className="text-[11px] text-slate-500">
                    CPF:{" "}
                    {socio?.cpf ? formatDocument(socio?.cpf) : "Não informado"}
                  </div>
                </div>
                <div className="text-center text-slate-700">
                  {socio?.entrada || "-"}
                </div>
                <div className="text-center">
                  <span
                    className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.2em] ${
                      socio?.indicador_debito?.toLowerCase() === "sim"
                        ? "border-rose-200 bg-rose-50 text-rose-600"
                        : "border-emerald-200 bg-emerald-50 text-emerald-600"
                    }`}
                  >
                    {socio?.indicador_debito || "-"}
                  </span>
                </div>
                <div className="space-y-1 text-[11px] text-slate-600">
                  {socio?.indicador_debito?.toUpperCase() === "SIM" ? (
                    <>
                      {socio?.restricoes_documento?.cheques_sem_fundo
                        ?.quantidade !== "0" && (
                        <div>
                          Cheques sem fundos:{" "}
                          <span className="text-rose-600 font-semibold">
                            {
                              socio?.restricoes_documento?.cheques_sem_fundo
                                ?.quantidade
                            }{" "}
                            ocorrências
                          </span>
                        </div>
                      )}

                      {socio?.restricoes_documento?.protestos?.quantidade !==
                        "0" && (
                        <div>
                          Protestos:{" "}
                          {renderValor(
                            socio?.restricoes_documento?.protestos?.valor
                          )}
                        </div>
                      )}

                      {socio?.restricoes_documento?.pendencias_restricoes
                        ?.quantidade !== "0" && (
                        <div>
                          Pendências:{" "}
                          {renderValor(
                            socio?.restricoes_documento?.pendencias_restricoes
                              ?.valor
                          )}
                        </div>
                      )}

                      {socio?.restricoes_documento?.acoes_judiciais
                        ?.quantidade !== "0" && (
                        <div>
                          Ações cíveis:{" "}
                          {renderValor(
                            socio?.restricoes_documento?.acoes_judiciais?.valor
                          )}
                        </div>
                      )}

                      {socio?.restricoes_documento
                        ?.falencias_recuperacao_judicial?.quantidade !==
                        "0" && (
                        <div>
                          Rec. judicial/Falências:{" "}
                          {renderValor(
                            socio?.restricoes_documento
                              ?.falencias_recuperacao_judicial?.valor
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="text-emerald-600">Não há débitos</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Administrador;
